import md5 from 'crypto-js/md5';
import createNewProduct from './createNewProduct';
import searchProductByHandle from './searchProductByHandle';
import updateProductVariant from './updateProductVariant';

const extractVariant = (product) => ({
  id: product.variants.edges[0].node.id,
  title: product.variants.edges[0].node.title,
  priceV2: {
    amount: product.variants.edges[0].node.price,
  },
});

const getCustomProduct = async (
  currentOptions,
  price,
  sku,
  productTitle,
  productImage,
  productType,
  compareAtPrice,
  customProductLink,
) => {
  const customProduct = {
    title: productTitle,
    handle: md5(
      currentOptions
        .filter((option) => typeof option.variant_id === 'number')
        .map((option) => option.variant_id)
        .sort()
        .join('-'),
    ).toString(),
    price,
    sku,
    compareAtPrice,
    productImage,
    productType: 'Custom',
    tags: [
      'custom',
      ...currentOptions
        .filter((option) => typeof option.variant_id === 'number')
        .map((option) => `VI:${option.variant_id.toString()}`),
      ...currentOptions
        .filter((option) => typeof option.variant_id === 'number')
        .map((option) => `${option.group_title}:${option.title}`),
    ],
  };
  if (productType) customProduct.tags.push(productType);
  const components = currentOptions.map((option, index) => {
    if (option.variant_id) {
      return {
        // key: option.variant_id.toString(),
        // value: `lineitem:${option.sku}`,
        key: `_lineitem${index + 1}`,
        value: JSON.stringify({
          title: option.title,
          variantId: option.variant_id.toString(),
        }),
      };
    }
    return null;
  });
  if (components && components.length) {
    components.unshift({ key: 'link', value: customProductLink });
  }
  const { product: productByHandle } = await searchProductByHandle(
    customProduct.handle,
  );

  // search if a product with same config and price already exists and has the
  // same price
  const productNode = productByHandle?.variants?.edges[0]?.node;
  

  if (productByHandle && parseInt(productNode.price, 10) === price) {
    const productByHandleVariant = extractVariant(productByHandle);
    productByHandleVariant.customAttributes = components;
    return { product: productByHandle, variant: productByHandleVariant };
  }

  // if product with same config exists but price is different - update the
  
  // price of existing product
  if (productByHandle && parseInt(productNode.price, 10) !== price) {
    const {
      productVariantUpdate: { product, productVariant },
    } = await updateProductVariant(productNode.id, {
      price,
      title: productNode.title,
      sku: productNode.title,
    });
    const updatedProductVariant = {
      id: productVariant.id,
      title: productVariant.title,
      priceV2: { amount: productVariant.price },
      customAttributes: components,
    };

    return { product, variant: updatedProductVariant };
  }

  // create a new product
  const {
    productCreate: { product: createdProduct },
  } = await createNewProduct(customProduct);
  const createdProductVariant = extractVariant(createdProduct);
  createdProductVariant.customAttributes = components;

  return { product: createdProduct, variant: createdProductVariant };
};

export default getCustomProduct;
